import { cartContent } from './cart-content.js';

function cartRemoveItem(){
  $(document).on('click', '.item-remove, .remove-icon', function(e) {
    const $this = $(this);
    e.preventDefault();
    $.ajax({
      url: $this.attr('href'),
    })
    .done(function(data) {
      if ($this.hasClass('.remove-icon')) {
        window.location.reload();
      }else{
        cartContent(data);
      }
    })
    
  })
}

export default cartRemoveItem();



// WEBPACK FOOTER //
// ../markup/assets/js/cart-remove-item.js